import React from 'react'
import ActionButton, { ActionButtonProps } from '.'
import classNames from 'classnames'
import './styles/cancelButton.scss'
import { useTranslation } from 'translations'

export const CancelButton = ({
    children,
    className,
    ...props
}: ActionButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
    const { t } = useTranslation()
    return (
        <ActionButton className={classNames('cancel-button', className)} {...props}>
            {children ?? t('common.cancel')}
        </ActionButton>
    )
}
